import { OrganizationType } from "../enums/organizationTypes";

/**
 * Helper function to get document type based on organization ID
 * @param orgId - The organization ID
 * @returns The corresponding document type for the organization
 */
export const getDocTypeFromOrg = (orgId: string): string => {
  const orgDocTypeMap: Record<string, string> = {
    [OrganizationType.NYCBS]: "Authorization / Referrals",
    [OrganizationType.CHC]: "Prior Auths",
    [OrganizationType.MBP]: "Authorizations",
    [OrganizationType.NYCBS_HYD]: "Authorization / Referrals",
    [OrganizationType.UCBC]: "Authorizations",
    [OrganizationType.GENESIS_CARE]: "Authorizations",
  };

  return orgDocTypeMap[orgId] || "Authorization / Referrals";
};

/**
 * Alternative function that returns the document type with type safety
 * @param orgId - The organization ID
 * @returns The corresponding document type or undefined if not found
 */
export const getDocTypeFromOrgStrict = (orgId: string): string | undefined => {
  const orgDocTypeMap: Record<string, string> = {
    [OrganizationType.NYCBS]: "Authorization / Referrals",
    [OrganizationType.CHC]: "Prior Auths",
    [OrganizationType.MBP]: "Authorizations",
    [OrganizationType.NYCBS_HYD]: "Authorization / Referrals",
    [OrganizationType.UCBC]: "Authorizations",
    [OrganizationType.GENESIS_CARE]: "Authorizations",
  };

  return orgDocTypeMap[orgId] || "Authorization / Referrals";
};
